import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="image-preview"
export default class extends Controller {
  static targets = ["input", "preview", "icon"];

  readURL() {
    const input = this.inputTarget;

    if (input.files && input.files[0]) {
      const reader = new FileReader();

      reader.onload = (e) => {
        // Set the uploaded image source and show it
        this.previewTarget.src = e.target.result;
        this.previewTarget.classList.remove("hidden");

        // Hide the default user icon if it exists
        if (this.hasIconTarget) {
          this.iconTarget.classList.add("hidden");
        }
      };

      reader.readAsDataURL(input.files[0]);
    }
  }
}
